/**
 * URL helpers for Posteingang deep links (`/i/:instanceId/inbox/:emailId`).
 * `inbox_emails.id` is a UUID.
 */

const INBOX_EMAIL_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const instancePrefix = (): string => {
  if (typeof window === 'undefined') return '';
  const match = window.location.pathname.match(/^\/i\/[^/]+/);
  return match ? match[0] : '';
};

export function parseInboxEmailIdParam(raw: string | undefined | null): string | null {
  if (raw == null) return null;
  const s = decodeURIComponent(String(raw)).trim();
  if (!s || !INBOX_EMAIL_ID_RE.test(s)) return null;
  return s;
}

/** Posteingang list, or a specific mail when `emailId` is a valid inbox UUID. */
export function inboxPath(emailId?: string | number | null): string {
  const base = `${instancePrefix()}/inbox`;
  if (emailId == null || emailId === '') return base;
  const id = parseInboxEmailIdParam(String(emailId));
  if (!id) return base;
  return `${base}/${encodeURIComponent(id)}`;
}

export function inboxThreadKey<T extends { id: string | number; thread_id?: string | null }>(mail: T): string {
  return mail.thread_id ? String(mail.thread_id) : `single-${mail.id}`;
}

/** Resolve a deep-linked mail by `inbox_emails.id` (exact row, not thread representative). */
export function resolveInboxMailForView<T extends { id: string | number }>(
  mailId: string,
  _threadEmails: T[],
  emails: T[],
): T | null {
  return emails.find((m) => String(m.id) === mailId) ?? null;
}
